export const scrollToTop = () => {
  window.scrollTo(0, 0)
}
